import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    overflow: 'auto'
  },
  pdfScaleContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
    marginTop: '16px'
  },
  pdfScaleLabel: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    lineHeight: '20px'
  }
});
